import React, {useState, useEffect, useContext, useRef} from "react";
import { useHistory } from 'react-router-dom';
import { DataContext } from '../context/DataContext';
import { AuthContext } from '../context/AuthContext';
import PageNav from '../components/PageNav';
import CbtIcon from '../svg/Cbt';
import Card from '../components/common/Card';
import classNames from 'classnames';
import Dropdown from '../svg/Dropdown';
// import Dropup from '../svg/DropUp';
import formatDbTimestamp from '../components/common/formatDbTimestamp';
import {toTitleCase} from '../util/titleCase';
import { useHeight2, useResizeObserver } from '../util/useHeight';
import Modal from '../components/common/Modal'

import axios from 'axios';
import { animated, useSpring, config } from "react-spring";
import LoadingModal from "../components/common/LoadingModal";
// import useDimensions from "react-cool-dimensions";

const Cbt = () => {
    const history = useHistory();
    const dataContext = useContext(DataContext);
    const authContext = useContext(AuthContext);
    const [showDropdown1, setShowDropdown1] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [showDropdown3, setShowDropdown3] = useState(false);
    const [showModal, setShowModal] = useState(false);
    // const [examStatusDet, setExamStatusDet] = useState([]);

    const [completedExams, setCompletedExams] = useState([]);
    const [ongoingExams, setOngoingExams] = useState([]);
    const [retakeExams, setRetakeExams] = useState([]);
    // const [heightRef1, height1] = useHeight();
    // const heightRef = useRef()
    const heightRef2 = useRef()
    // const height2 = useHeight2(heightRef2);
    // const { height } = useDimensions(heightRef, {
    //     useBorderBoxSize: true
    // })
    const [ref, {target}] = useResizeObserver();
    const [heightRef1, entry] = useResizeObserver();
    const [heightRef3, entry3] = useResizeObserver();
    
    const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
    const admissionnumber = studentInfo[0].admissionnumber;
    // const schoolDomain = window.location.host;
    const schoolDomain = localStorage.getItem('schoolDomain');

    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1 font-semibold"> CBT Center </span>
        </>
    );
    const pageSvg = () => (
        <>
            <CbtIcon />
        </>
    );

    useEffect(() => {
        const cbtDataBody = {
          SchoolUrl: schoolDomain,
          admissionnumber
        }
        const getExamStatusDetails = async () => {
          try {
              setShowModal(true)
              const { data } = await axios.post(`student/examstatus?admissionnumber=${admissionnumber}`, cbtDataBody);
              console.log(data)
              if (data.status) {
                setShowModal(false)
                // setExamStatusDet(data.data);
                setCompletedExams(data.data[0].completedExams);
                setOngoingExams(data.data[0].ongoingExams);
                setRetakeExams(data.data[0].retakeExams)
              } else {
                setShowModal(false)
                alert('Something went wrong. Please try again later')
              }
          } catch (error) {
              console.log('get cbt exam status error', error);
              setShowModal(false);
              alert('Something went wrong. Please try again later')
          }
        };
        getExamStatusDetails();
    }, []);

    const testDetails = [
        {
            subject: 'Mathematics',
            testType: 'Exam',
            class: 'JSS2A',
            term: '1st Term',
            lastTaken: 'Aug 26'
        },
        {
            subject: 'Computer Science',
            testType: 'CA',
            class: 'JSS2A',
            term: '1st Term',
            lastTaken: 'Aug 23'
        },
        {
            subject: 'Basic Technology',
            testType: 'Exam',
            class: 'JSS2A',
            term: '1st Term',
            lastTaken: 'Aug 26'
        }
    ];

    const transitionStyle = useSpring({
        to: [
            { opacity: 1, transform: 'translateY(0)' },
        ],
        from: { opacity: 0, transform: 'translateY(-80px)' },
        config: { duration: 700 }
    });

    const dropdownTStyles = useSpring({
        config: { ...config.stiff, duration: 750 },
        from: { height: 0 },
        to: {
          opacity: showDropdown1 ? 1 : 0,
          height: showDropdown1 && target && target.offsetHeight 
        },
        leave: { height: 0 }
    });

    const dropdownTStyles2 = useSpring({
        config: { ...config.stiff, duration: 750 },
        from: { opacity: 0, height: 0 },
        to: {
          opacity: showDropdown2 ? 1 : 0,
          height: showDropdown2 && entry.target ? entry.target.offsetHeight : 0
        },
        leave: { height: 0 }
    });

    const dropdownTStyles3 = useSpring({
        config: { ...config.stiff, duration: 750 },
        from: { opacity: 0, height: 0 },
        to: {
          opacity: showDropdown3 ? 1 : 0,
          height: showDropdown3 && entry3.target ? entry3.target.offsetHeight : 0
        },
        leave: { height: 0, duration: 750 }
    });

    const rotateDropdown1 = useSpring({
        config: { ...config.stiff, duration: 750 },
        to: {
            transform : showDropdown1 ? 'rotate(60deg)' : 'rotate(0deg)'
        },
    });

    const rotateDropdown2 = useSpring({
        config: { ...config.stiff, duration: 750 },
        to: {
            transform : showDropdown2 ? 'rotate(60deg)' : 'rotate(0deg)'
        },
    });

    const rotateDropdown3 = useSpring({
        config: { ...config.stiff, duration: 750 },
        to: {
            transform : showDropdown3 ? 'rotate(60deg)' : 'rotate(0deg)'
        },
    });

    const handleStartTest = (item) => {
        localStorage.removeItem('ongoingAnsweredQsts');
        dataContext.setClickedCbtItem(item);
        authContext.setIsExamOngoing(true);
        localStorage.setItem('clickedCbtItem', JSON.stringify(item));
        history.push('test')
    }

    const handleRetakeStartTest = (item) => {
        localStorage.removeItem('ongoingAnsweredQsts');
        dataContext.setClickedCbtItem(item);
        localStorage.setItem('clickedCbtItem', JSON.stringify(item));
        history.push('test')
    }

    target && console.log(target.offsetHeight, target)

    return (
        <animated.div style={transitionStyle} className='block mx-auto sm:pl-20 w-full sm:block'>
            {showModal && <LoadingModal />}
            <div className='w-full sm:w-3/4 pt-2 z-0'>
                <PageNav Heading={Heading} PageSvg={pageSvg} />
                <div className='mt-4'>
                    <Card>
                        <div className='flex flex-col items-center p-8'>
                            <div onClick={()=>{setShowDropdown1(!showDropdown1)}} className='flex justify-between cursor-pointer items-center w-full'>
                                <div className='flex flex-col'>
                                    <span className='text-gray-200 leading-5 text-sm font-medium'> Ongoing </span>
                                    <span className='mt-3 text-blue-100 text-2xl leading-8 font-medium'> {!ongoingExams.length ? 'No Subject' : ongoingExams.length === 1 ? '1 Subject' : `${ongoingExams.length}${''} Subjects`} </span>
                                </div>
                                <animated.div style={rotateDropdown1} className='w-12 h-12 flex justify-center items-center cursor-pointer'>
                                    <Dropdown />
                                </animated.div>
                            </div>
                            { ongoingExams.map((details, index) => {
                                const dropDown = classNames({
                                    'w-full mt-4 cursor-pointer': true,
                                    'hidden': !showDropdown1
                                })
                                return (
                                    <div key={index} onClick={() => handleStartTest(details)} className={dropDown}>
                                        <animated.div style={{ ...dropdownTStyles, overflow: 'visible'}}>
                                            <div ref={ref} className='flex pl-2 w-full hover:bg-gray-700 rounded-md justify-between items-center border-b border-gray-600 py-3'>
                                                <div className='flex flex-1 flex-col mr-1'>
                                                    <span className='text-xs sm:text-sm text-gray-200 font-medium max-w-prose'> {toTitleCase(details.subjectname)} </span>
                                                    <span className='text-xs text-gray-300 font-medium mt-2 opacity-50'> {details.division_name} </span>
                                                </div>
                                                <div className='flex flex-1 flex-col'>
                                                    <span className='text-xs sm:text-sm text-gray-200 font-medium truncate'> {toTitleCase(details.termx)} </span>
                                                    <span className='text-xs text-gray-300 font-medium mt-2 opacity-50'> {details.classx} </span>
                                                </div>
                                                <div className='flex flex-1 flex-col items-center'>
                                                    <span className='text-xs sm:text-sm text-gray-200 font-medium truncate'> {formatDbTimestamp(details.timestamp)} </span>
                                                    <span className='text-xs text-gray-300 font-medium mt-2 opacity-50'> Last Taken </span>
                                                </div>
                                            </div>
                                        </animated.div>
                                    </div>
                                )})
                            }
                        </div>
                    </Card>
                </div>
                <div className='mt-4'>
                    <Card>
                        <div className='flex flex-col items-center cursor-pointer p-8'>
                            <div onClick={()=>{setShowDropdown2(!showDropdown2)}} className='flex justify-between items-center w-full'>
                                <div className='flex flex-col'>
                                    <span className='text-gray-200 leading-5 text-sm font-medium'> Open for Retake </span>
                                    <span className='mt-3 text-blue-100 text-2xl leading-8 font-medium'> {!retakeExams ? 'No Subject' : retakeExams.length === 1 ? '1 Subject' : `${retakeExams.length} Subjects` } </span>
                                </div>
                                <animated.div style={rotateDropdown2} className='w-12 h-12 flex justify-center items-center cursor-pointer'>
                                    <Dropdown />
                                </animated.div>
                            </div>
                            { retakeExams.map( (details, index) => {
                                // console.log(details)
                                const dropDown = classNames({
                                    'w-full mt-4 cursor-pointer': true,
                                    'hidden': !showDropdown2
                                })
                                return (
                            <div key={index} onClick={() => handleRetakeStartTest(details)} className={dropDown}>
                                <animated.div style={{ ...dropdownTStyles2, overflow: 'visible'}}>
                                    <div ref={heightRef1} className='flex w-full justify-between items-center hover:bg-gray-700 rounded-md border-b border-gray-600 pl-2 py-3'>
                                        <div className='flex flex-1 flex-col'>
                                            <span className='text-xs sm:text-sm text-gray-200 font-medium'> {toTitleCase(details.subjectname)} </span>
                                            <span className='text-xs sm:text-sm text-gray-300 font-medium mt-2 opacity-50'> {toTitleCase(details.division_name)} </span>
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <span className='text-xs sm:text-sm text-gray-200 font-medium'> {toTitleCase(details.termx)} </span>
                                            <span className='text-xs sm:text-sm text-gray-300 font-medium mt-2 opacity-50'> {details.classx} </span>
                                        </div>
                                        <div className='flex flex-1 flex-col justify-end'>
                                            <span className='text-xs sm:text-sm text-gray-200 font-medium'> {formatDbTimestamp(details.timestamp)} </span>
                                            <span className='text-xs sm:text-sm text-gray-300 font-medium mt-2 opacity-50'> Last Taken </span>
                                        </div>
                                    </div>
                                </animated.div>
                            </div>
                            )})}
                        </div>
                    </Card>
                </div>
                <div className='mt-4 mb-20'>
                    <Card>
                        <div className='flex flex-col items-center cursor-pointer p-8'>
                            <div onClick={()=>{setShowDropdown3(!showDropdown3)}} className='flex justify-between items-center w-full'>
                                <div className='flex flex-col'>
                                    <span className='text-gray-200 leading-5 text-sm font-medium'> Completed </span>
                                    <span className='mt-3 text-blue-100 text-2xl leading-8 font-medium'> {!completedExams ? 'No Subject' : completedExams.length === 1 ? '1 Subject' : `${completedExams.length} Subjects` }  </span>
                                </div>
                                <animated.div style={rotateDropdown3} className='w-12 h-12 flex justify-center items-center cursor-pointer'>
                                    <Dropdown />
                                </animated.div>
                            </div>
                            { completedExams.map((details, index) => {
                                // console.log(details)
                                const dropDown = classNames({
                                    'w-full mt-4': true,
                                    'hidden': !showDropdown3
                                })
                                return (
                            <div key={index} className={dropDown}>
                                <animated.div style={{ ...dropdownTStyles3, overflow: 'visible'}}>
                                    <div ref={heightRef3} className='flex w-full justify-between items-center rounded-md border-b border-gray-600 py-3'>
                                        <div className='flex flex-1 flex-col'>
                                            <span className='text-xs sm:text-sm text-gray-200 font-medium'> {toTitleCase(details.subjectname)} </span>
                                            <span className='text-xs sm:text-sm text-gray-300 font-medium mt-2 opacity-50'> {details.testType || 'Exam'} </span>
                                        </div>
                                        <div className='flex flex-1 flex-col'>
                                            <span className='text-xs sm:text-sm text-gray-200 font-medium'> {toTitleCase(details.term) || 'Term'} </span>
                                            <span className='text-xs sm:text-sm text-gray-300 font-medium mt-2 opacity-50'> {details.classx} </span>
                                        </div>
                                        {/* <div className='flex flex-1 flex-col justify-end'>
                                            <span className='text-sm text-gray-200 font-medium'> {details.lastTaken || 'Score'} </span>
                                            <span className='text-xs text-gray-300 font-medium mt-2 opacity-50'> {details.timestamp ? formatDbTimestamp(details.timestamp) : ''} </span>
                                        </div> */}
                                    </div>
                                </animated.div>
                            </div>
                            )})}
                        </div>
                    </Card>
                </div>
            </div>
        </animated.div>
    )
}

export default Cbt;